import { render, staticRenderFns } from "./OTUploads.vue?vue&type=template&id=13ebb29f&scoped=true&lang=pug"
import script from "./OTUploads.vue?vue&type=script&lang=js"
export * from "./OTUploads.vue?vue&type=script&lang=js"
import style0 from "./OTUploads.vue?vue&type=style&index=0&id=13ebb29f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ebb29f",
  null
  
)

export default component.exports